<template>
  <div id="feedback_log">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('title.my_feedback')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <van-row>
      <van-col span="24" class="feedback_top">
        <van-tabs v-model="active" @click="onTabClick" line-width="5vw">
          <van-tab :title="$t('column.waiting_for_reply')" name="2"></van-tab>
          <van-tab :title="$t('column.pending')" name="0"></van-tab>
          <van-tab :title="$t('column.solved')" name="1"></van-tab>
        </van-tabs>
      </van-col>
      <van-col span="22" offset="1" v-if="list.length">
        <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('other.there_is_no_more')"
            @load="onLoad"
        >
          <van-cell v-for="(item,i) in list" :key="i">
            <van-col span="24" class="ranking_log_item"  @click="jumpHref(item)">
              <van-col span="12" class="ranking_log_item_title">{{ item.title }}</van-col>
              <van-col span="12" class="ranking_log_item_status">{{ item.status === '1' ? $t('column.solved') : item.status === '0' ? $t('column.pending') : $t('column.waiting_for_reply') }}</van-col>
              <van-col span="24" class="ranking_log_item_center">{{ item.feedback_text }}</van-col>
              <van-col span="12" class="ranking_log_item_time">{{ item.create_time }}</van-col>
              <van-col span="12" class="ranking_log_item_k"><van-icon name="arrow" /></van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>
      <van-col class="ranking_log_k" span="22" offset="1" v-else>
        <img src="../assets/img/feedback_log_0.png"/>
      </van-col>
      <van-col span="22" offset="1" class="feedback_log_bottom">
        <van-button color="#FF61F5" block round @click="onClickButton('feedback')">{{ $t('column.questioning') }}</van-button>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import Toast from 'vant/lib/toast'
import axios from "axios";

export default {
  data() {
    return {
      active: 2,
      loading: false,
      list: [],
      finished: false,
      page: 1
    }
  },
  created() {
    this.getlist()
  },
  methods: {
    onLoad() {
      // 异步更新数据
      if (this.page > 1) {
        this.getlist()
      }
    },
    jumpHref(item) {
      const token = this.$route.query.token
      const uid = this.$route.query.uid
      this.$router.push({
        path: "/feedback_message",
        query:{ token: token, uid: uid,ticket_id: item.ticket_id }
      })
    },
    onTabClick(name,title) {
      this.page = 1
      this.list = []
      this.finished = false
      this.getlist()
    },
    onClickButton(name) {
      const token = this.$route.query.token
      const uid = this.$route.query.uid
      this.$router.push({
        path: "/" + name,
        query:{ token: token, uid: uid }
      })
    },
    getlist(){
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=feedback_list",{ params:{ uid: uid, token: token, p: this.page, status: this.active }}).then(res =>{
        toast.clear(); // 关闭加载提示
        // 加载状态结束
        this.loading = false
        if (res.data.status === 0) {
          Toast(res.data.error)
          this.finished = true
          return false
        }
        if (this.page === 1) {
          this.list = []
          this.finished = false
        }
        for(let i = 0; i< res.data.data.length; i ++) {
          this.list.push(res.data.data[i])
        }
        // 数据全部加载完成
        if (res.data.data.length <= 0) {
          this.finished = true
        }
        this.page ++
      })
    },
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/feedback_log.vue